import { atom } from 'jotai'

/**
 * 車両属性マスタのインポートModalの表示状態
 */
export const isOpenTruckTypeImportModalAtom = atom<boolean>(false)

isOpenTruckTypeImportModalAtom.debugLabel = 'isOpenTruckTypeImportModalAtom'
